import { createContext, useContext } from 'react';

import { MongoAbility as Ability, createMongoAbility as createAbility } from '@casl/ability';

import { IRoleEnabledUser } from './interfaces';
import { parsePermission } from './parsePermission';

export const ability = createAbility([]);

/**
 * Sets abilities to ones belonging to provided user.
 *
 * Permissions contained within user role should be in either common or core format.
 */
export const updateAbility = (user: IRoleEnabledUser) =>
  ability.update(user.role.permissions.map((permission) => parsePermission(permission)));

/** Clears abilities set. */
export const clearAbilities = () => ability.update([]);

export const AbilityContext = createContext<Ability>(ability);

export const useAbility = (): Ability => useContext(AbilityContext);
